import moment from "moment";

export const convertDateToISO = (date: string) => {
  if (!date) return null;
  const momentDate = moment.isMoment(date) ? date : moment(date);
  const isValid = momentDate.isValid();

  if (!isValid) return null;

  return momentDate.toISOString();
};

export const convertUTCToLocalDate = (utcISOString) => {
  if (!utcISOString) return null;

  const localDate = moment.utc(utcISOString).local();
  return localDate.format("DD/MM/YYYY HH:mm");
};

export const formatDate = (date: string, format: string = "DD/MM/YYYY") => {
  if (!date) return null;

  const isDate = moment(date).isValid();

  if (!isDate) return null;

  return moment(date).format(format);
};
